import i from"styled-components";import{theme as o}from"../../../theme.js";const r=i.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: ${o.boxShadow};
  width: 80%;
  border-radius: ${o.radius}px;
  background-color: ${o.colors.shades[0]};
  > div {
    border-radius: 6px;
  }
`,a=i.div`
  background-color: #33333338;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 20;
  top: 0;
  left: 0;
`,e=i.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${o.spacing*4}px;
  margin-top: ${o.spacing*12}px;
`,t=i.p`
  margin: 0 ${o.spacing*4}px 0;
  color: ${o.colors.gray[500]};
  line-height: 24px;
  @media screen and (max-width: ${o.breakpoints.md}) {
    margin: ${o.spacing*3}px 0 0;
  }
`;export{a as BackgroundContainer,t as Description,e as FlexWrapper,r as ModalContainer};
